// @flow
import { SEARCH_SET_DATA } from 'actions/search';

const INITIAL_STATE = null;

export default function reduce(state = INITIAL_STATE, { type, data }) {
  switch (type) {
    case SEARCH_SET_DATA:
      return data || null;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/search.js